<template>
  <v-container id="init-home-container" class="mt-0 d-flex">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-row>
      <v-col cols="12">
        <v-spacer></v-spacer>
        <titlecard></titlecard>
        <v-spacer></v-spacer>
        <!-- <frontdeskcards></frontdeskcards> -->
        <!-- <v-spacer></v-spacer> -->

        <!-- Cards -->
        <image_gallery></image_gallery>

        <!-- <v-main>
      <v-container
        class="cmpbk black--text"
        id="home-container"
        style="max-width: 768px; background-color: #e0e0e0"
      >
        <h1 style="color: white">Home Component</h1>
      </v-container>
    </v-main> -->
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #init-home-container {
    width: 100%;
  }
  #home-container {
    height: auto;
  }

  #all-panels {
    width: 97%;
  }

  #faq-other {
    width: 97%;
    margin: 0 auto;
  }

  .theme--light.v-expansion-panels .v-expansion-panel {
    color: white;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #all-panels {
    width: 95%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  #init-home-container {
    width: 95%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import titlecard from "../components/titlecard";
import frontdeskcards from "../components/frontdeskcards";
import image_gallery from "../components/image_gallery";

export default {
  name: "Home",
  components: {
    titlecard,
    frontdeskcards,
    image_gallery,
  },
  mixins: [bus_common],
  data() {
    return {};
  },
  watch: {},
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
